<template lang="pug">
div#navbar-n-wrap
  nav.navbar.is-fixed-top
      .navbar-brand
        router-link#logo(to="/home")
          img(src="@/assets/images/logos/guidancenetwork-logo-white.png")
      button.reset.button.navbar-burger(:class="{'is-active': menuActive}" @click="menuActive = !menuActive")
        span
        span
        span
      .navbar-menu(:class="{'is-active': menuActive}")
        .navbar-end
          .frow.row-center
            span.nav-item
              router-link.nav-link(
                :class="{'active': activePage('/hub')}"
                to="/guides"
              ) Browse Guides
            span.nav-item
              VButton(
                v-if="!$store.getters.isLoggedIn"
                type="primary"
                text="Join"
                @click.native="$router.push('/register')"
              )
            span.nav-item(v-if="this.$store.getters.token")
              router-link.nav-link(
                :class="{'active': activePage('/dashboard')}"
                to="/dashboard"
              )
                img(
                  v-if="$store.getters.user.photoUrl"
                  :src="$store.getters.user.photoUrl"
                  class="profile-image"
                )
                i(v-else).fas.fa-user-circle.fa-2x
</template>
<script>
export default {
  data: () => ({
    menuActive: false
  }),

  methods: {
    activePage(page) {
      return page === window.location.pathname;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#logo img {
  margin: 10px;
  max-width: 150px;
  width: 100%;
  height: auto;
}

.navbar-menu,
.navbar-brand {
  background-color: $black-soft;
}
#navbar-no-wrap {
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
#navbar {
  background-color: #ffffff;
  opacity: 0.97;
  position: fixed;
  width: 100%;
  z-index: 1;

  ul {
    align-items: center;
  }

  div {
    display: flex;
    justify-content: space-between;
  }
}
.nav-link {
  display: inline-block;
  font-size: 15px;
  letter-spacing: 2px;
  font-weight: 700;
  text-transform: uppercase;

  @media (max-width: 767px) {
    font-size: 11px;
  }
}
.profile-image {
  border-radius: 50%;
  height: 40px;
  width: 40px;
}
// mobile nav
.navbar-burger {
  min-width: 20px;
  position: absolute;
  right: 5px;
  top: 5px;

  span {
    background: $clr-primary;
  }
}
.navbar-menu {
  align-items: center;
  text-align: center;
}
.nav-item {
  padding: 0 10px;

  a {
    color: $white;
    text-decoration: none;

    &:hover {
      color: $clr-primary;
    }

    &.active {
      color: $clr-primary;
    }
  }

  &:last-child {
    padding-right: 30px;
  }
}
</style>
